import { takeEvery } from 'redux-saga/effects';
import { fetchVideoAttachmentsEffect } from './effect';
import { actions } from './actions';

export const videoAttachmentsSaga = function* () {
  yield takeEvery(actions.VIDEO_ATTACHMENTS_FETCH_REQUEST, fetchVideoAttachmentsEffect);
};
